export default __webpack_public_path__ + "static/rec-s3-6523f32b9149362bea4579537717f3e3.png";